import { useContext } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Action } from '../../store/actions';
import { ApplicationContext } from '../../store/context';
import { lock_hooks } from '@axo/shared/data-access/hooks';

export function useCloseApplication(marketCountry: string) {
  const { dispatch, state } = useContext(ApplicationContext);
  const myLocks = lock_hooks.useCurrentUserLocks(marketCountry);
  const unlock = lock_hooks.useUnlockApplications(marketCountry);
  const navigate = useNavigate();
  const location = useLocation();
  const { applicationID: openedAppId } = useParams();

  async function closeAndUnlockMultiple(applicationIDs: string[]) {
    const actions = applicationIDs.map<Action>((id) => ({
      type: 'Close application',
      scope: {
        parentType: 'navigation',
        id,
      },
    }));
    for (const action of actions) dispatch(action);

    if (openedAppId && applicationIDs.includes(openedAppId)) {
      const remaining = Object.keys(state.openApplications).filter(
        (openApplication) => !applicationIDs.includes(openApplication)
      );

      // Find and set second to last of open applications.
      const numRemaining = remaining.length;
      let selectedApplicationID = '';
      let path = '/';
      if (numRemaining === 1) {
        selectedApplicationID = remaining[0];
        path = `/application/${selectedApplicationID}`;
      }
      if (numRemaining > 1) {
        selectedApplicationID = remaining[numRemaining - 1];
        path = `/application/${selectedApplicationID}`;
      }

      navigate(`${path}${location.search}`);
    }

    const lockedApps = myLocks.data
      ? myLocks.data.Items.filter(({ LoanApplicationID }) =>
          applicationIDs.includes(LoanApplicationID)
        )
      : [];

    if (lockedApps.length) {
      await unlock.mutateAsync(lockedApps.map((x) => x.LoanApplicationID));
    }
  }

  async function closeAndUnlock(applicationID: string) {
    closeAndUnlockMultiple([applicationID]);
  }

  return { closeAndUnlock, closeAndUnlockMultiple };
}
